(() => {
  window.swinger.observer.initialize('.swinger-amateur', (elem) => {
    const itemNumber = elem.getAttribute('data-id');
    if (itemNumber) {
      window.swinger.api.trackLastSeen('amateur', itemNumber);
    }
  }, false);
})();
